import {
  ICONS_ENUM,
  Panel,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@sanlam-glacier/app-common/components';
import styles from '../exposure-breakdown-takeover.module.scss';
import clsx from 'clsx';
import { Reg28ExposureBreachModelMock } from '../../../../types/regulation-28/regulation-28.interfaces';

type RetirementAnnuityPanelProps = {
  breaches: Reg28ExposureBreachModelMock[];
};

export const RetirementAnnuityPanel = ({ breaches }: RetirementAnnuityPanelProps) => {
  const testComponentName = 'regulation28RetirementAnnuityPanel';

  const headers = [
    {
      label: 'Breach Details',
      key: 'breachDetails'
    },
    {
      label: 'Exposure %',
      key: 'exposurePercentage'
    },
    {
      label: 'Limit %',
      key: 'limitPercentage'
    }
  ];

  return (
    <div>
      <Panel
        data-testid={`${testComponentName}`}
        className={styles.retirementAnnuityDropdown}
        displayDropdown
        heading={{
          children: (
            <Typography data-testid={`${testComponentName}Heading`} variant={Typography.VARIANT.H5}>
              Retirement Annuity (99 days not compliant)
            </Typography>
          )
        }}
        icon={ICONS_ENUM.ALERT_ERROR}
      >
        <Table>
          <TableHead className={styles.retirementAnnuityTableHeader}>
            {headers.map((header, index) => (
              <TableCell className={clsx(index !== 0 && styles.percentageColumn)} key={header.key}>
                <Typography
                  data-testid={`${testComponentName}${header.label}ColHeading`}
                  align={index === 0 ? Typography.ALIGN.LEFT : Typography.ALIGN.RIGHT}
                  variant={Typography.VARIANT.B4}
                  weight={Typography.WEIGHT.MEDIUM}
                  color={Typography.COLOR.SECONDARY}
                >
                  {header.label}
                </Typography>
              </TableCell>
            ))}
          </TableHead>
          <TableBody>
            {breaches.map((row, index) => (
              <TableRow data-testid={`${testComponentName}Breach${row.assetClassName}`} key={index}>
                <TableCell align={TableCell.ALIGN.LEFT}>
                  <Typography
                    data-testid={`${testComponentName}AssetClass${index}Name`}
                    variant={Typography.VARIANT.B4}
                    weight={Typography.WEIGHT.NORMAL}
                    color={Typography.COLOR.DEFAULT}
                  >
                    {row.assetClassName}
                  </Typography>
                </TableCell>
                <TableCell className={styles.percentageColumn}>
                  <Typography
                    data-testid={`${testComponentName}AssetClass${index}ExposurePercentage`}
                    align={Typography.ALIGN.RIGHT}
                    variant={Typography.VARIANT.B4}
                    weight={Typography.WEIGHT.NORMAL}
                    color={Typography.COLOR.DEFAULT}
                  >
                    {row.exposurePercentage.toFixed(2) ?? '-'}
                  </Typography>
                </TableCell>
                <TableCell className={styles.percentageColumn}>
                  <Typography
                    data-testid={`${testComponentName}AssetClass${index}LimitPercentage`}
                    align={Typography.ALIGN.RIGHT}
                    variant={Typography.VARIANT.B4}
                    weight={Typography.WEIGHT.NORMAL}
                    color={Typography.COLOR.DEFAULT}
                  >
                    {row.limitPercentage.toFixed(2) ?? '-'}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Panel>
    </div>
  );
};
